__turbopack_context__.v({
  "card": "ServicesPortfolio-module__wPwKoG__card",
  "cardDesc": "ServicesPortfolio-module__wPwKoG__cardDesc",
  "cardTitle": "ServicesPortfolio-module__wPwKoG__cardTitle",
  "fadeIn": "ServicesPortfolio-module__wPwKoG__fadeIn",
  "fadeUp": "ServicesPortfolio-module__wPwKoG__fadeUp",
  "float": "ServicesPortfolio-module__wPwKoG__float",
  "heading": "ServicesPortfolio-module__wPwKoG__heading",
  "headingBlock": "ServicesPortfolio-module__wPwKoG__headingBlock",
  "iconWrap": "ServicesPortfolio-module__wPwKoG__iconWrap",
  "pinkStrip": "ServicesPortfolio-module__wPwKoG__pinkStrip",
  "sectionWrapper": "ServicesPortfolio-module__wPwKoG__sectionWrapper",
  "stripTitle": "ServicesPortfolio-module__wPwKoG__stripTitle",
  "subheading": "ServicesPortfolio-module__wPwKoG__subheading",
});
